import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, memo } from "react";
import { FormControl, TextField } from "@mui/material";
import FormInput from "Root/profile/components/common/FormInput";
import FormCheckbox from "Root/profile/components/common/FormCheckbox";
import { apiQuizSignUp } from "Root/api/apiQuiz";
import toastService from "Root/profile/toastService";
import ReviewsPage from "CheckoutComponents/ReviewsPage";
import { useTracking } from "react-tracking";
import QuizTrack from "Root/quiz/data/trackingEnums";
import styles from "./style.module.scss";
import ButtonBar from "../buttonBar/buttonBar";
import RegFont from "Root/profile/components/common/RegFont";
import H2Font from "Root/profile/components/common/H2Font";
import { useLocation } from "react-router";
import DrawerComponent from "ProfileComponents/common/DrawerComponent";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import { formControlStyles, labelStyles, } from "Root/checkout/components/CheckoutConfirmNew/data";
import { posthog } from "posthog-js";
import H4Font from "Root/profile/components/common/H4Font";
import { cvgTrack } from "Root/utils/tracking";
export function validateEmail(emailArg) {
    const re = 
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(emailArg);
}
const EmailSignUp = ({ quizAnswers, postSignupUrl, showGuestCheckout }) => {
    const [email, setEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [ready, setReady] = useState(false);
    const [smsConsent, setSMSConsent] = useState(false);
    const [altSubmitted, setAltSubmitted] = useState(false);
    const [emailExist, setEmailExist] = useState(false);
    const [isInvisible, setIsInvisible] = useState(false);
    const { pathname } = useLocation();
    const { trackEvent } = useTracking();
    const trackEmailSignUp = () => {
        trackEvent({
            funComponent: "quiz",
            event: `${QuizTrack.email_sign_up}`,
        });
    };
    const closeDrawer = () => {
        setEmailExist(false);
    };
    const isMobile = useScreenWidth() < 999;
    const setEmailValue = (e) => {
        setEmail(e);
        setEmailExist(false);
    };
    const setNameValue = (e) => {
        setName(e);
    };
    const setPhoneValue = (e) => {
        setPhone(e);
    };
    useEffect(() => {
        setShow(true);
        const creds = localStorage.getItem("future_creds");
        if (creds) {
            setEmail(JSON.parse(creds).email);
            setName(JSON.parse(creds).name);
        }
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [submitted]);
    useEffect(() => {
        if (emailExist) {
            submitData(false);
            setEmailExist(false);
        }
    }, [email]);
    const submitNewData = () => {
        setEmail(newEmail);
        if (newEmail) {
            cvgTrack({
                aliases: [`urn:email:${newEmail}`],
                eventName: "Added Email In Quiz",
                profileProperties: {
                    $email: newEmail,
                },
            });
        }
    };
    const submitData = async (guest) => {
        setAltSubmitted(false);
        if (!validateEmail(email.trim()) && !guest) {
            toastService.errorMessage("Please enter a valid email");
            return;
        }
        try {
            setSubmitted(true);
            const body = {
                email: email.trim(),
                name,
                phone,
                smsConsent,
                quizAnswers,
                postSignupUrl,
                guest,
            };
            const respData = await apiQuizSignUp(body);
            posthog.capture("quiz_email_signup", body);
            setReady(true);
            trackEmailSignUp();
            cvgTrack({
                aliases: [`urn:email:${email.trim()}`],
                eventName: "Added Email In Quiz",
                profileProperties: {
                    $email: email.trim(),
                },
            });
            setIsInvisible(true);
            if (postSignupUrl !== "") {
                if (postSignupUrl === "/hyrox-results/") {
                    localStorage.setItem("hyroxResults", JSON.stringify(respData));
                }
                window.location.href = postSignupUrl;
            }
            if (respData?.postSignupURL) {
                window.location.href = respData.postSignupURL;
            }
        }
        catch (e) {
            setSubmitted(false);
            if (e.message.indexOf("Not Acceptable") >= 0) {
                toastService.errorMessage("Email already exists", 6000, "", false, {
                    target: "#quiz-target",
                });
                setIsInvisible(false);
                setEmailExist(true);
                setShow(false);
                setShow(true);
            }
            else {
                toastService.errorMessage("Could not save data");
                setShow(false);
                setShow(true);
            }
        }
    };
    const disableSubmit = name === "" || email === "";
    const disableNewSubmit = !validateEmail(newEmail.trim()) || newEmail === email;
    function getPhoneNumber(number) {
        if (number === undefined) {
            return "";
        }
        const numbers = number.match(/\d/g);
        if (numbers !== null) {
            return numbers.join("");
        }
        return "";
    }
    function formatPhone(num) {
        const numeric_part = getPhoneNumber(num);
        const first_three = numeric_part.slice(0, 3);
        const second_three = numeric_part.slice(3, 6);
        const last_four = numeric_part.slice(6, 10);
        let final_form = "";
        if (first_three.length === 0) {
            final_form = "";
        }
        else if (first_three.length < 3) {
            final_form = `(${first_three}`;
        }
        else if (second_three.length === 0) {
            final_form = `(${first_three}`;
        }
        else if (second_three.length < 3) {
            final_form = `(${first_three})-${second_three}`;
        }
        else if (last_four.length === 0) {
            final_form = `(${first_three})-${second_three}`;
        }
        else {
            final_form = `(${first_three})-${second_three}-${last_four}`;
        }
        return final_form;
    }
    const verifyPhone = (value) => {
        const formatedPhone = formatPhone(value);
        setPhoneValue(formatedPhone);
        if (value) {
            setSMSConsent(true);
        }
    };
    const smsConsentChange = () => {
        setSMSConsent(!smsConsent);
    };
    const btnLabel = pathname.indexOf("target") !== -1 ? "See My Results" : "Next";
    const noun = pathname.indexOf("target") !== -1 ? "guide" : "formulas";
    return (_jsxs(_Fragment, { children: [submitted ? (_jsx(ReviewsPage, { fullname: name, ready: ready })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: `${styles.quizWrapper} ${isInvisible ? styles.quizWrapperHide : ""}`, id: "quiz-target", children: _jsxs("div", { className: styles.emailSignUp, children: [_jsxs("div", { className: styles.emailSignUpTitle, children: [_jsx("div", { className: styles.readyh3, children: _jsxs(H4Font, { fontWeight: 400, children: ["Ready to get your personalized ", noun, "?"] }) }), _jsx("span", { children: _jsxs(RegFont, { children: [" ", "Enter your info to view the details of your personalized", " ", noun, "!"] }) })] }), _jsx(FormControl, { fullWidth: true, sx: { ...formControlStyles, marginBottom: "24px" }, children: _jsx(TextField, { InputLabelProps: {
                                            style: labelStyles,
                                        }, InputProps: {
                                            style: {
                                                backgroundColor: "#fff",
                                            },
                                        }, id: "name", label: "Name", variant: "outlined", value: name, onChange: (event) => setNameValue(event.target.value), required: true, autoComplete: "given-name" }) }), _jsx(FormControl, { fullWidth: true, sx: { ...formControlStyles, marginBottom: "24px" }, children: _jsx(TextField, { error: submitted && (!validateEmail(email) || emailExist), InputLabelProps: {
                                            style: labelStyles,
                                        }, type: "email", InputProps: {
                                            style: {
                                                backgroundColor: "#fff",
                                            },
                                        }, id: "email", label: "Email", variant: "outlined", value: email, onChange: (event) => setEmailValue(event.target.value), required: true, autoComplete: "email", helperText: submitted &&
                                            (emailExist
                                                ? "Email already exists"
                                                : !validateEmail(email)
                                                    ? "Please enter a valid email"
                                                    : "") }) }), _jsx(FormControl, { fullWidth: true, sx: { ...formControlStyles, marginBottom: "24px" }, children: _jsx(TextField, { InputLabelProps: {
                                            style: labelStyles,
                                        }, InputProps: {
                                            style: {
                                                backgroundColor: "#fff",
                                            },
                                            //@ts-ignore
                                            pattern: "(?d{3})?-? *d{3}-? *-?d{4}",
                                        }, id: "phone", label: "Mobile Phone (Optional)", variant: "outlined", value: phone, onChange: (event) => verifyPhone(event.target.value), autoComplete: "phone", inputMode: "numeric" }) }), phone !== "" && (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.smsConsent, children: _jsx(FormCheckbox, { checked: smsConsent, id: "sms", name: "sms_opt_in", onChange: smsConsentChange, value: "sms", extraStyle: {
                                                    fontSize: "12px",
                                                    fontFamily: "Halyard",
                                                    maxWidth: "100%",
                                                    textTransform: "initial",
                                                }, label: "You agree to receive recurring automated marketing messages, including cart reminders, \n                      at the phone number provided. Consent is not a condition of purchase. Reply STOP to unsubscribe. \n                      Reply HELP for help. Message frequency varies. Msg & data rates may apply. \n                      View our Privacy Policy and Terms of Service." }) }), _jsx("a", { className: "truevault-polaris-privacy-notice", href: "https://privacy.gainful.com/privacy-policy#financial-incentive", rel: "noreferrer", hidden: true, target: "_blank", children: "Notice of Financial Incentive" })] })), _jsxs("p", { style: {
                                        fontFamily: "Halyard",
                                        fontSize: "12px",
                                        textAlign: "center",
                                        marginTop: "12px",
                                    }, children: ["By continuing, you agree to our\u00A0", _jsx("a", { target: "_blank", href: "/terms/", style: { textDecoration: "underline" }, children: "terms" }), " ", "and", " ", _jsx("a", { target: "_blank", href: "/terms/", style: { textDecoration: "underline" }, children: "privacy policy" }), "\u00A0", _jsx("a", { className: "truevault-polaris-privacy-notice", href: "https://privacy.gainful.com/privacy-policy#california-privacy-notice", rel: "noreferrer", hidden: true, target: "_blank", style: { textDecoration: "underline" }, children: "California Privacy Notice" }), "\u00A0 & will receive emails from Gainful"] }), email === "" && showGuestCheckout && (_jsx("div", { className: styles.guestBtnContainer, children: _jsx(UnderlinedButton, { label: "Continue as Guest", onClick: () => submitData(true) }) }))] }) }), _jsx(ButtonBar, { label: btnLabel, disabled: disableSubmit, gonext: () => submitData(false), showBottom: show, scrolledToBottom: false }, "buttonbar")] })), _jsx(DrawerComponent, { open: emailExist, toggleDrawer: () => closeDrawer, anchor: isMobile ? "bottom" : "right", crossButton: true, drawerClassName: styles.powderbackground, children: _jsxs("div", { className: styles.modalContainer, children: [_jsxs(H2Font, { children: ["Welcome back ", name.split(" ")[0], "!"] }), _jsxs(RegFont, { children: ["We see that you have already completed a quiz with this email. To access your results, please verify your email by clicking the link we just sent to ", email] }), _jsx("hr", { className: styles.modalhr }), _jsx(RegFont, { children: "Don\u2019t have access to this email?" }), _jsx("br", {}), _jsx(RegFont, { children: "Enter a new email here to access your results" }), _jsx(FormInput, { type: "email", className: styles.modalFormInput, name: "email", value: newEmail, onChange: setNewEmail, label: "Email" }), _jsx("div", { className: styles.modalBtnContainer, children: _jsx(RoundedGainfulButton, { onClick: submitNewData, disabled: disableNewSubmit, label: "Submit", extraClassName: styles.modalBtn }) })] }) })] }));
};
export default memo(EmailSignUp);
